import React from "react";
import DismissibleIntro from "@/components/DismissibleIntro";
import ApeUploader from "@/components/ApeUploader";
import { usePropertyDetail } from "../context";

export default function DocumentiTab() {
  const { id, property, setProperty, tab } = usePropertyDetail();
  return (
      <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-8" data-testid="tab-documenti">
        <div className="lg:col-span-7">
          <DismissibleIntro storageKey="propertydetail:documenti-intro" className="mb-6">
            <span className="overline">Documenti dell'annuncio</span>
            <h3 className="font-editorial text-2xl sm:text-3xl mt-2">I tuoi file ufficiali</h3>
            <p className="text-sm text-[#6B6A65] mt-2 max-w-md">
              Qui carichi i documenti dell'immobile. Pronto legge i dati e li mostra in modo ordinato sull'annuncio pubblico.
            </p>
          </DismissibleIntro>
          <ApeUploader
            propertyId={id}
            currentClass={property?.energy_class}
            onUpdate={(ec, summary) => setProperty((p) => p && ({ ...p, energy_class: ec, energy_summary: summary }))}
          />
          <p className="mt-6 text-[11.5px] text-[#9A968B] italic leading-relaxed">
            Prossimamente: visure catastali, planimetrie catastali originali, certificati ulteriori.
          </p>
        </div>
      </div>
  );
}
